export const previewerNavigationActions = {
    setDrawerState,
    setShowNavigationLayout
};

function setDrawerState(isOpen) {
    return dispatch => {
      return dispatch({ type: "SET_DRAWER_STATE", payload: isOpen });
    };
}

function setShowNavigationLayout(isOpen) {
    return dispatch => {
      return dispatch({ type: "SET_SHOW_NAVIGATION_LAYOUT", payload: isOpen });
    };
}